export const ALLOW_WEBCAM_HINT_TIMEOUT = 500;
export const MAKEUP_API_VERSION = 'v3.6';
export const HAIR_API_VERSION = 'v3.5';
